import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Invoice} from '../../../../shared/interface/invoice';
import {first} from 'rxjs/operators';
import {Uuid} from '../../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {InvoiceService} from '../../../../shared/services/invoice.service';
import {MatSnackBar} from '@angular/material/snack-bar';

export interface ChangeStatusData {
  invoice: Invoice;
  enableNote: boolean;
  noteLabel: string;
  actionCode: string;
  newStatusName: string;
  tagLine: string;
}

@Component({
  selector: 'app-change-status-dialog',
  templateUrl: './change-status-dialog.component.html',
  styleUrls: ['./change-status-dialog.component.scss']
})
export class ChangeStatusDialogComponent implements OnInit {

  changeStatusForm: FormGroup;
  noteControl: FormControl;

  processingRequest = false;

  constructor(
    public dialogRef: MatDialogRef<ChangeStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeStatusData,
    private fb: FormBuilder,
    private invoiceService: InvoiceService,
    private snackBar: MatSnackBar,
  ) {
    this.changeStatusForm = fb.group({
      note: this.noteControl = fb.control('', data.enableNote ? [Validators.required] : [])
    });
  }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  sendForm(): void {
    this.processingRequest = true;
    this.invoiceService.changeStatus(
      this.data.invoice.uuid,
      this.data.actionCode,
      this.changeStatusForm.value,
    )
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snackBar.open('Pomyślnie zmieniono status', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      });
  }
}
